import { API, PLANS, ROLES } from 'config';

import { includes, isArray, intersection, merge, indexOf, keys } from 'lodash';

const AUTH = API.AUTH;

function AuthService($http, $rootScope, $localStorage) {

  'ngInject';

  this.setCredentials = (user) => {
    $localStorage.user = user;
    $rootScope.$broadcast('authenticated', true);
  };

  this.fetch = () => {
    $http.get(API.USER)
    .then((response) => {
      this.setCredentials(response.data);
    })
    .catch((err) => {
      throw err;
    });
  };

  this.clearCredentials = () => {
    delete $localStorage.user;
  };

  this.getAuthenticatedUser = () => $localStorage.user;

  this.getRoles = () => this.getAuthenticatedUser().roles;

  this.hasRoles = (roles) => {
    let hasRoles = false;
    const userRoles = this.getRoles();
    if (isArray(roles)) {
      hasRoles = intersection(userRoles, roles).length > 0;
    } else {
      hasRoles = includes(userRoles, roles);
    }
    return hasRoles;
  };

  this.getPlan = () => this.getAuthenticatedUser().plan;
  this.hasProfressionalPlan = () => this.getPlan() === PLANS.PROFESSIONAL;
  this.hasEnterprisePlan = () => this.getPlan() === PLANS.ENTERPRISE;
  this.hasExpertoPlan = () => this.getPlan() === PLANS.EXPERTO;
  this.hasValidacionPlan = () => this.getPlan() === PLANS.VALIDACION;
  this.hasFreePlan = () => indexOf(keys(PLANS), this.getPlan()) === -1;
  this.hasPlan = () => !this.hasFreePlan();

  return {

    login: (email, password) => {
      const data = {
        username: email,
        password,
      };
      const headers = {
        'content-type' : 'application/x-www-form-urlencoded',
      };
      return $http.post(`${AUTH.LOGIN}?username=${email}&password=${password}`, data, headers);
    },

    logout: () => {
      $rootScope.$broadcast('authenticated', false);
      this.clearCredentials();
      return $http.get(AUTH.LOGOUT);
    },

    ping: () => $http.get(API.PING),

    signup: (email, password, companyName) => {
      const data = {
        email,
        password,
        confirmPassword: password,
        companyName,
      };
      return $http.post(AUTH.SIGNUP, data);
    },

    verifyAccount: (email, token) => {
      const data = {
        email,
        token,
      };
      return $http.post(AUTH.VERIFY_ACCOUNT, data);
    },

    forgotPassword: (email) => {
      const data = {
        email,
      };
      return $http.post(AUTH.FORGOT_PASSWORD, data);
    },

    changePassword: (email, token, password) => {
      const data = {
        email,
        token,
        password,
      };
      return $http.post(AUTH.CHANGE_PASSWORD, data);
    },

    updatePassword: (currentPassword, newPassword) => {
      const data = {
        currentPassword,
        newPassword,
      };
      return $http.post(AUTH.UPDATE_PASSWORD, data);
    },

    mergeCredentials: (user) => this.setCredentials(merge(this.getAuthenticatedUser(), user)),
    setCredentials: (user) => this.setCredentials(user),
    clearCredentials: () => this.clearCredentials(),
    fetch: () => this.fetch(),
    isAuthenticated: () => typeof this.getAuthenticatedUser() !== 'undefined',
    getAuthenticatedUser: () => this.getAuthenticatedUser(),
    getUserId: () => this.getAuthenticatedUser().id,
    getCompanyId: () => this.getAuthenticatedUser().companyId,
    getPlan: () => this.getPlan(),
    hasExpertoPlan: () => this.hasExpertoPlan(),
    hasValidacionPlan: () => this.hasValidacionPlan(),
    hasProfressionalPlan: () => this.hasProfressionalPlan(),
    hasEnterprisePlan: () => this.hasEnterprisePlan(),
    hasPlan: () => this.hasPlan(),
    hasRoles: (roles) => this.hasRoles(roles),
    isUser: () => this.hasRoles(ROLES.USER),
    isAdmin: () => this.hasRoles(ROLES.ADMIN),

    canSeeCuantitativeResults: () => !this.hasFreePlan(),
    canGenerateReports: () => !(this.hasExpertoPlan() || this.hasValidacionPlan()),
    canEditParameters: () => !this.hasValidacionPlan(),
    canCompareProjects: () => !this.hasFreePlan(),
  };
}

export default AuthService;



// WEBPACK FOOTER //
// ./src/services/Auth.js